import { create } from 'zustand';

type TextEditorStore = {
  text: string;
  maxStringLength: number;
  isValidString: boolean;
  setText: (text: string) => void;
  setIsValidString: (isValid: boolean) => void;
  resetStore: () => void;
};

export const useTextEditorStore = create<TextEditorStore>()((set) => ({
  text: '',
  maxStringLength: 10,
  isValidString: false,
  setText: (text: string) => {
    set({ text: text });
  },
  setIsValidString: (isValid: boolean) => {
    set({ isValidString: isValid });
  },
  resetStore: () => {
    set(() => ({
      isValidString: false,
      text: '',
    }));
  },
}));
